import { Component, OnInit } from '@angular/core';
import { CommonService } from '../core/common.service';
import { NgForm } from '@angular/forms';
import { RoleType, Employee, UserApi, AppUser } from '../core/api.gen';
import { AuthService } from '../core/auth.service';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from 'src/app/core/toast.service';
import { finalize, map } from 'rxjs/operators';
import { LoaderService } from '../core/loader.service';
import { Location } from '@angular/common';
import { DEFAULT_EDITOR_TOOLBAR_CONFIG } from '../core';

@Component({
  selector: '[eos-appsettings]',
  templateUrl: './app-settings.component.html'
})
export class AppSettingsComponent implements OnInit {

  setdelegate: string;
  currentUser: AppUser;
  delegateId: number;
  userList: Employee[] = [];
  emailSignature: string;
  toolbarConfig = { ...DEFAULT_EDITOR_TOOLBAR_CONFIG, 
    height:300,
    width: 800 
  };
  delegateSaved:boolean = false;
  
  constructor(
    private common: CommonService,
    private authService: AuthService,
    private userAPI: UserApi,
    private toast: ToastService,
    private loader: LoaderService,
    private _location: Location,
  ) { }

  ngOnInit() {
    this.currentUser = this.authService.ActiveUser;
    this.getUserList();
    this.getUserDetails();
  }

  getUserList() {
    this.userAPI.getEmployeesByRole(this.roleType)
      .subscribe(resp => {
        this.userList = resp.filter(({ id }) => id !== this.currentUser.employeeId);
      });
  }

  get roleType(): RoleType {
    const activeRole = this.currentUser.activeRole.trim().split(' ').join('_');
    return RoleType[activeRole];
  }

  getUserDetails() {
    this.userAPI.getUserDetails(this.currentUser.userId)
      .subscribe(resp => {
        if (resp.delegateId) {
          this.delegateId = resp.delegateId;   
          this.delegateSaved = true;       
        } else {
          this.delegateId = 0;
          this.delegateSaved = false;
        }
        this.emailSignature = resp.emailSignature;
      });
  }
  getDefaultEmailSignature() {
    this.userAPI.getDefaultEmailSignature()
      .subscribe(resp => { this.emailSignature = resp; });
  }
  SaveUserDetails() {
    this.userAPI.saveUserDelegate(this.currentUser.userId, this.delegateId)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          return this.toast.handleServerValidationMessage(err);
        }),
        map(result => {
          return result;
        })
        , finalize(() => {
          this.loader.clear();
        })).subscribe(resp => {
          if (this.delegateId !== 0) {
            this.toast.success("Delegate set successfully!");
            this.delegateSaved = true; 
          } else {
            this.toast.success("Delegate removed successfully!");
            this.delegateSaved = false
          }
          this.common.delegateStatus$.next(this.delegateId > 0);
        });
  }
  saveEmailSignature() {
    this.currentUser.emailSignature = this.emailSignature;
    this.userAPI.saveEmailSignature(this.currentUser)
      .pipe().subscribe(resp => {
        this.toast.success("Signature saved successfully!");
      }, (err) => {
        this.toast.error('Error occured while saving.');
      });
  }

  setNoDelegate(f: NgForm) {
    if (this.delegateId === 0) {
      return;
    }
    this.delegateId = 0;
    this.delegateSaved = false;
    this.SaveUserDetails();
  }
  updateDelegate(f: NgForm) {
    if (this.delegateId === 0) {
      this.toast.error("Please select a delegate");
      return;
    }
    this.SaveUserDetails();
  }

  onClose() {
    this._location.back();
  }
}
